import Vue from "vue";
import featureToggling from "./feature-toggling";
import experiments from "./experiments";
import devices from "./devices";

const mixins = [featureToggling, experiments, devices];
mixins.forEach((mixin) => Vue.mixin(mixin));
